export function ensureProtocol(url) {
  // Check if the string starts with either "https://" or "http://"
  if (!url.includes("://")) {
    // If not, add "https://" to the beginning of the string
    url = "https://" + url;
  }
  return url;
}
